import { Site, SLD } from '@patsnap-utils/biz';
import { HELP_URL_EU } from 'library-components/constant/urls';
import '@patsnap-ui/icon/assets/solid/BookmarkBook.svg';
import '@patsnap-ui/icon/assets/solid/users.svg';
import _ from 'lodash';
function getCNMenu(i18n) {
    return [
        {
            icon: 'SolidHelpCentre',
            href: new Site({ sld: SLD.HELP, pathname: 'help' }).href,
            label: i18n.t('snapBusiness.headerV2.growth.helpCenter'),
        },
        {
            icon: 'SolidBookmarkBook',
            href: 'https://x.zhihuiya.com/#/profession/industryDetail/1713748928955609090',
            label: i18n.t('snapBusiness.headerV2.growth.courseLearning'),
            classname: 'track-header-course-learning',
        },
        {
            icon: 'SolidUsers',
            href: 'https://talk.zhihuiya.com/?source12=product',
            label: i18n.t('snapBusiness.headerV2.growth.patsnapCommunity'),
            classname: 'track-header-patsnap-community',
        }
    ];
}
function getInternationalMenu(i18n, isUS) {
    return [
        {
            icon: 'SolidHelpCentre',
            label: i18n.t('snapBusiness.headerV2.growth.helpCenter'),
            href: isUS
                ? new Site({ sld: SLD.HELP, pathname: 'hc/en-us/signin' }).href
                : HELP_URL_EU,
        },
        {
            icon: 'SolidUsers',
            href: 'https://help.patsnap.com/hc/en-us/community/topics',
            label: i18n.t('snapBusiness.headerV2.growth.patsnapCommunity'),
        },
        {
            icon: 'SolidConversation',
            label: i18n.t('snapBusiness.headerV2.growth.askForHelp'),
            href: new Site({ sld: SLD.HELP, pathname: 'hc/en-us/requests/new' }).href,
        }
    ];
}
function getCommonMenu(i18n, isCN) {
    return [
        null,
        {
            icon: 'Term',
            href: isCN ? 'https://www.zhihuiya.com/legal/terms' : 'https://www.patsnap.com/legal',
            label: i18n.t('snapBusiness.headerV2.growth.terms'),
        },
        {
            icon: 'Privacy',
            href: isCN ? 'https://www.zhihuiya.com/legal/privacy' : 'https://www.patsnap.com/legal/privacy-policy',
            label: i18n.t('snapBusiness.headerV2.growth.policy'),
        }
    ];
}
export function getHelpCenter(i18n, headerService) {
    const region = _.get(headerService, 'account._info.site_region');
    const isCN = region === 'CN';
    const isUS = region === 'US';
    const menu = isCN ? getCNMenu(i18n) : getInternationalMenu(i18n, isUS);
    const commonMenu = getCommonMenu(i18n, isCN);
    return {
        icon: 'HelpCenter',
        trigger: 'hover',
        menu: [...menu, ...commonMenu],
    };
}
export function initHelpCenter(i18n, headerService) {
    if (!headerService.right)
        headerService.right = [];
    headerService.right.push(getHelpCenter(i18n, headerService));
}
